import { render } from "./voiceImage.vue?vue&type=template&id=6d32ec4f&scoped=true"
import script from "./voiceImage.vue?vue&type=script&lang=js"
export * from "./voiceImage.vue?vue&type=script&lang=js"

import "./voiceImage.vue?vue&type=style&index=0&id=6d32ec4f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d32ec4f"]])

export default __exports__